import React, { useState, useEffect } from 'react'
import { getList } from './apis'
import {
  useResetDependentFields2,
  useResetDependentFields,
} from './useResetDependentFields'
import {
  trialStatusOptions,
  judgmentOutcomeOptions,
  sentenceTypeOptions,
  statusOptions,
  untracedOptions,
  yesNoOptions,
  acceptedRejectedOptions,
} from './delinquencies_constants'
import Select from "react-select";

const FIRForm = ({ formik }) => {
  const [sectionOption, setSectionOption] = useState()
  const [policeStationOptions, setPoliceStation] = useState()

  useEffect(() => {
    const getSectionOption = async () => {
      const data = await getList('section')
      setSectionOption([
        ...data,
        {
          name: 'Other',
          description: '',
          type: 'section',
          parentId: [],
          id: 'other',
        },
      ])
    }
    const getPoliceStation = async () => {
      const data = await getList('police_station')
      setPoliceStation(data)
    }
    getSectionOption()
    getPoliceStation()
  }, [])

  useResetDependentFields(formik, 'section', ['other'], ['otherSection'])

  useResetDependentFields2(
    formik,
    'status',
    ['untraced'],
    [
      'cancellationOutcome',
      'cancellationCctnsDate',
      'challanSubmitted',
      'challanDate',
      'challanCctnsDate',
      'chargesFramed',
      'chargesDate',
      'trialStatus',
      'judgmentDate',
      'judgmentOutcome',
      'judgmentAgainstAppeal',
      'judgmentDetailsOfAppeal',
      'sentenceType',
      'imprisonmentDurationYears',
      'imprisonmentDurationMonths',
      'imprisonmentDurationDays',
      'bothSentenceMonths',
      'bothSentenceYears',
      'bothSentenceDays',
      'bothSentenceFine',
      'fineAmount',
    ]
  )

  // under investigation
  useResetDependentFields2(
    formik,
    'status',
    ['investigation'],
    [
      'untracedOutcome',
      'untracedCctnsDate',
      'cancellationOutcome',
      'cancellationCctnsDate',
      'challanSubmitted',
      'challanDate',
      'challanCctnsDate',
      'chargesFramed',
      'chargesDate',
      'trialStatus',
      'judgmentDate',
      'judgmentOutcome',
      'judgmentAgainstAppeal',
      'judgmentDetailsOfAppeal',
      'sentenceType',
      'imprisonmentDurationYears',
      'imprisonmentDurationMonths',
      'imprisonmentDurationDays',
      'bothSentenceMonths',
      'bothSentenceYears',
      'bothSentenceDays',
      'bothSentenceFine',
      'fineAmount',
    ]
  )

  // untraced
  useResetDependentFields2(
    formik,
    'status',
    ['untraced'],
    [
      'cancellationOutcome',
      'cancellationCctnsDate',
      'challanSubmitted',
      'challanDate',
      'challanCctnsDate',
      'chargesFramed',
      'chargesDate',
      'trialStatus',
      'judgmentDate',
      'judgmentOutcome',
      'judgmentAgainstAppeal',
      'judgmentDetailsOfAppeal',
      'sentenceType',
      'imprisonmentDurationYears',
      'imprisonmentDurationMonths',
      'imprisonmentDurationDays',
      'bothSentenceMonths',
      'bothSentenceYears',
      'bothSentenceDays',
      'bothSentenceFine',
      'fineAmount',
    ]
  )

  // cancellation
  useResetDependentFields2(
    formik,
    'status',
    ['cancellation'],
    [
      'untracedOutcome',
      'untracedCctnsDate',
      'challanSubmitted',
      'challanDate',
      'challanCctnsDate',
      'chargesFramed',
      'chargesDate',
      'trialStatus',
      'judgmentDate',
      'judgmentOutcome',
      'judgmentAgainstAppeal',
      'judgmentDetailsOfAppeal',
      'sentenceType',
      'imprisonmentDurationYears',
      'imprisonmentDurationMonths',
      'imprisonmentDurationDays',
      'bothSentenceMonths',
      'bothSentenceYears',
      'bothSentenceDays',
      'bothSentenceFine',
      'fineAmount',
    ]
  )

  // challan submitted
  useResetDependentFields2(
    formik,
    'status',
    ['challan'],
    [
      'untracedOutcome',
      'untracedCctnsDate',
      'cancellationOutcome',
      'cancellationCctnsDate',
    ]
  )

  // challan submitted child
  useResetDependentFields2(
    formik,
    'challanSubmitted',
    ['no'],
    [
      'challanDate',
      'chargesFramed',
      'chargesDate',
      'trialStatus',
      'judgmentDate',
      'judgmentOutcome',
      'judgmentAgainstAppeal',
      'judgmentDetailsOfAppeal',
      'sentenceType',
      'imprisonmentDurationYears',
      'imprisonmentDurationMonths',
      'imprisonmentDurationDays',
      'bothSentenceMonths',
      'bothSentenceYears',
      'bothSentenceDays',
      'bothSentenceFine',
      'fineAmount',
    ]
  )
  // charges framed
  useResetDependentFields2(
    formik,
    'chargesFramed',
    ['no'],
    [
      'chargesDate',
      'trialStatus',
      'judgmentDate',
      'judgmentOutcome',
      'judgmentAgainstAppeal',
      'judgmentDetailsOfAppeal',
      'sentenceType',
      'imprisonmentDurationYears',
      'imprisonmentDurationMonths',
      'imprisonmentDurationDays',
      'bothSentenceMonths',
      'bothSentenceYears',
      'bothSentenceDays',
      'bothSentenceFine',
      'fineAmount',
    ]
  )

  // trial status is not trial completed
  useResetDependentFields(
    formik,
    'trialStatus',
    ['trialCompleted'],
    [
      'judgmentDate',
      'judgmentOutcome',
      'judgmentAgainstAppeal',
      'judgmentDetailsOfAppeal',
      'sentenceType',
      'imprisonmentDurationYears',
      'imprisonmentDurationMonths',
      'imprisonmentDurationDays',
      'bothSentenceMonths',
      'bothSentenceYears',
      'bothSentenceDays',
      'bothSentenceFine',
      'fineAmount',
    ]
  )

  useResetDependentFields2(
    formik,
    'judgmentOutcome',
    ['acquitted'],
    [
      'sentenceType',
      'imprisonmentDurationYears',
      'imprisonmentDurationMonths',
      'imprisonmentDurationDays',
      'bothSentenceMonths',
      'bothSentenceYears',
      'bothSentenceDays',
      'bothSentenceFine',
      'fineAmount',
    ]
  )

  useResetDependentFields2(
    formik,
    'sentenceType',
    ['bothImprisonmentAndFine'],
    [
      'imprisonmentDurationYears',
      'imprisonmentDurationMonths',
      'imprisonmentDurationDays',
      'fineAmount',
    ]
  )

  useResetDependentFields2(
    formik,
    'sentenceType',
    ['fine'],
    [
      'imprisonmentDurationYears',
      'imprisonmentDurationMonths',
      'imprisonmentDurationDays',
      'bothSentenceMonths',
      'bothSentenceYears',
      'bothSentenceDays',
      'bothSentenceFine',
    ]
  )

  useResetDependentFields2(
    formik,
    'sentenceType',
    ['imprisonment'],
    [
      'fineAmount',
      'bothSentenceMonths',
      'bothSentenceYears',
      'bothSentenceDays',
      'bothSentenceFine',
    ]
  )

  useResetDependentFields2(
    formik,
    'sentenceType',
    ['punishmentUndergone'],
    [
      'imprisonmentDurationYears',
      'bothSentenceMonths',
      'bothSentenceYears',
      'bothSentenceFine',
      'bothSentenceDays',
      'imprisonmentDurationDays',
      'imprisonmentDurationMonths',
      'fineAmount',
    ]
  )


  useEffect(() => {
    if (formik.initialValues.otherSection) {
      formik.setFieldValue(
        "otherSection",
        formik.initialValues.otherSection
      )
    }
  }, [formik.initialValues.section])


  useEffect(() => {
    if (formik.initialValues.otherPoliceStation) {
      formik.setFieldValue(
        "otherPoliceStation",
        formik.initialValues.otherPoliceStation
      )
    }
  }, [formik.initialValues.policeStation])





  return (
    <>
      {/* 🔹 FIR Basic Details */}
      {/* <pre>{JSON.stringify({ values: formik.values, errors: formik.errors, touched: formik.touched, InitialValues: formik.initialValues }, null, 2)}</pre> */}

      <div className="form-group row mb-3">
        <label className="col-sm-4 col-form-label">
          FIR Number <span style={{ color: 'red' }}>*</span>
        </label>
        <div className="col-sm-8">
          <input
            type="text"
            className="form-control"
            name="firNumber"
            value={formik.values.firNumber}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.firNumber && formik.errors.firNumber && (
            <div className="invalid-feedback d-block">
              {formik.errors.firNumber}
            </div>
          )}
        </div>
      </div>

      <div className="form-group row mb-3">
        <label className="col-sm-4 col-form-label">
          FIR Date <span style={{ color: 'red' }}>*</span>
        </label>
        <div className="col-sm-8">
          <input
            type="date"
            className="form-control"
            name="firDate"
            value={formik.values.firDate}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            onClick={(e) => e.target.showPicker && e.target.showPicker()}
          />
          {formik.touched.firDate && formik.errors.firDate && (
            <div className="invalid-feedback d-block">
              {formik.errors.firDate}
            </div>
          )}
        </div>
      </div>

      <div className="form-group row mb-3">
        <label className="col-sm-4 col-form-label">
          Police Station <span style={{ color: 'red' }}>*</span>
        </label>
        <div className="col-sm-8">
          <select
            className="form-control"
            name="policeStation"
            value={formik.values.policeStation}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          >
            <option value="">Select</option>
            {policeStationOptions?.map((opt) => (
              <option key={opt.id} value={opt.id}>
                {opt.name}
              </option>
            ))}
            <option value="other">Other</option>

          </select>
          {formik.touched.policeStation && formik.errors.policeStation && (
            <div className="invalid-feedback d-block">
              {formik.errors.policeStation}
            </div>
          )}

          {formik.values.policeStation === "other" && (
            <input
              type="text"
              className="form-control mt-2"
              name="otherPoliceStation"
              placeholder="Please Enter Other Police Station"
              value={formik.values.otherPoliceStation}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          )}

          {formik.touched.otherPoliceStation && formik.errors.otherPoliceStation && (
            <div className="text-danger">{formik.errors.otherPoliceStation}</div>
          )}
        </div>
      </div>

      {/* <div className="form-group row mb-3">
        <label className="col-sm-4 col-form-label">
          Section <span style={{ color: 'red' }}>*</span>
        </label>
        <div className="col-sm-8">
          <select
            className="form-control"
            name="section"
            value={formik.values.section}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          >
            <option value="">Select</option>
            {sectionOption?.map((opt) => (
              <option key={opt.id} value={opt.id}>
                {opt.name}
              </option>
            ))}
          </select>
          {formik.touched.section && formik.errors.section && (
            <div className="invalid-feedback d-block">
              {formik.errors.section}
            </div>
          )}
        </div>
      </div> */}
      <div className="form-group row mb-3">
        <label className="col-sm-4 col-form-label">
          Section <span style={{ color: "red" }}>*</span>
        </label>

        <div className="col-sm-8">
          <Select
            isMulti
            name="section"
            options={sectionOption?.map((opt) => ({
              value: opt.id,
              label: opt.name
            }))}
            value={sectionOption
              ?.filter((opt) => formik.values.section.includes(opt.id))
              .map((opt) => ({
                value: opt.id,
                label: opt.name
              }))
            }
            onChange={(selected) => {
              const values = selected ? selected.map((item) => item.value) : [];
              formik.setFieldValue("section", values);
            }}
            onBlur={() => formik.setFieldTouched("section", true)}
          />

          {formik.touched.section && formik.errors.section && (
            <div className="invalid-feedback d-block">
              {formik.errors.section}
            </div>
          )}
        </div>
      </div>

      {/* 🔸 other section */}
      {formik.values.section?.includes('other') && (
        <>
          <div className="form-group row mb-3">
            <label className="col-sm-4 col-form-label">
              Other Section <span style={{ color: 'red' }}>*</span>
            </label>
            <div className="col-sm-8">
              <input
                type="text"
                className="form-control"
                name="otherSection"
                value={formik.values.otherSection}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.otherSection && formik.errors.otherSection && (
                <div className="invalid-feedback d-block">
                  {formik.errors.otherSection}
                </div>
              )}
            </div>
          </div>
        </>
      )}

      <div className="form-group row mb-3">
        <label className="col-sm-4 col-form-label">
          Allegations <span style={{ color: 'red' }}>*</span>
        </label>
        <div className="col-sm-8">
          <textarea
            className="form-control"
            name="allegations"
            value={formik.values.allegations}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.allegations && formik.errors.allegations && (
            <div className="invalid-feedback d-block">
              {formik.errors.allegations}
            </div>
          )}
        </div>
      </div>



      {/* 🔹 Status Workflow */}
      <div className="form-group row mb-3">
        <label className="col-sm-4 col-form-label">
          Status <span style={{ color: 'red' }}>*</span>
        </label>
        <div className="col-sm-8">
          <select
            className="form-control"
            name="status"
            value={formik.values.status}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          >
            <option value="">Select Status</option>
            {statusOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
          {formik.touched.status && formik.errors.status && (
            <div className="invalid-feedback d-block">
              {formik.errors.status}
            </div>
          )}
        </div>
      </div>

      {/* 🔸 Untraced */}
      {formik.values.status === 'untraced' && (
        <>


          <div className="form-group row mb-3">
            <label className="col-sm-4 col-form-label">
              Date of submission of final report in CCTNS
            </label>
            <div className="col-sm-8">
              <input
                type="date"
                className="form-control"
                name="untracedCctnsDate"
                value={formik.values.untracedCctnsDate}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                onClick={(e) => e.target.showPicker && e.target.showPicker()}
              />
              {formik.touched.untracedCctnsDate &&
                formik.errors.untracedCctnsDate && (
                  <div className="invalid-feedback d-block">
                    {formik.errors.untracedCctnsDate}
                  </div>
                )}
            </div>
          </div>

          <div className="form-group row mb-3">
            <label className="col-sm-4 col-form-label">Outcome</label>
            <div className="col-sm-8">
              <select
                className="form-control"
                name="untracedOutcome"
                value={formik.values.untracedOutcome}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <option value="">Select</option>
                {untracedOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
              {formik.touched.untracedOutcome &&
                formik.errors.untracedOutcome && (
                  <div className="invalid-feedback d-block">
                    {formik.errors.untracedOutcome}
                  </div>
                )}
            </div>
          </div>
        </>
      )}

      {/* 🔸 Cancellation */}
      {formik.values.status === 'cancellation' && (
        <>
          <div className="form-group row mb-3">
            <label className="col-sm-4 col-form-label">
              Date of submission of final report in CCTNS
            </label>
            <div className="col-sm-8">
              <input
                type="date"
                className="form-control"
                name="cancellationCctnsDate"
                onBlur={formik.handleBlur}
                value={formik.values.cancellationCctnsDate}
                onChange={formik.handleChange}
                onClick={(e) => e.target.showPicker && e.target.showPicker()}
              />
              {formik.touched.cancellationCctnsDate &&
                formik.errors.cancellationCctnsDate && (
                  <div className="invalid-feedback d-block">
                    {formik.errors.cancellationCctnsDate}
                  </div>
                )}
            </div>
          </div>
          <div className="form-group row mb-3">
            <label className="col-sm-4 col-form-label">Outcome</label>
            <div className="col-sm-8">
              <select
                className="form-control"
                name="cancellationOutcome"
                value={formik.values.cancellationOutcome}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <option value="">Select</option>
                {acceptedRejectedOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
              {formik.touched.cancellationOutcome &&
                formik.errors.cancellationOutcome && (
                  <div className="invalid-feedback d-block">
                    {formik.errors.cancellationOutcome}
                  </div>
                )}
            </div>
          </div>


        </>
      )}

      {/* 🔸 Challan Submission Workflow */}
      {formik.values.status === 'challan' && (
        <>
          <div className="form-group row mb-3">
            <label className="col-sm-4 col-form-label">
              Date of submission of final report in CCTNS
            </label>
            <div className="col-sm-8">
              <input
                type="date"
                className="form-control"
                name="challanCctnsDate"
                onBlur={formik.handleBlur}
                value={formik.values.challanCctnsDate}
                onChange={formik.handleChange}
                onClick={(e) => e.target.showPicker && e.target.showPicker()}
              />
              {formik.touched.challanCctnsDate &&
                formik.errors.challanCctnsDate && (
                  <div className="invalid-feedback d-block">
                    {formik.errors.challanCctnsDate}
                  </div>
                )}
            </div>
          </div>
          <div className="form-group row mb-3">
            <label className="col-sm-4 col-form-label">
              Is Challan Submitted in court ?
            </label>
            <div className="col-sm-8">
              <select
                className="form-control"
                name="challanSubmitted"
                value={formik.values.challanSubmitted}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <option value="">Select</option>
                {yesNoOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
              {formik.touched.challanSubmitted &&
                formik.errors.challanSubmitted && (
                  <div className="invalid-feedback d-block">
                    {formik.errors.challanSubmitted}
                  </div>
                )}
            </div>
          </div>

          {formik.values.challanSubmitted === 'yes' && (
            <>
              <div className="form-group row mb-3">
                <label className="col-sm-4 col-form-label">
                  Date of Submission of challan in court
                </label>
                <div className="col-sm-8">
                  <input
                    type="date"
                    className="form-control"
                    name="challanDate"
                    value={formik.values.challanDate}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    onClick={(e) =>
                      e.target.showPicker && e.target.showPicker()
                    }
                  />
                  {formik.touched.challanDate && formik.errors.challanDate && (
                    <div className="invalid-feedback d-block">
                      {formik.errors.challanDate}
                    </div>
                  )}
                </div>
              </div>

              {/* Charges framed */}
              <div className="form-group row mb-3">
                <label className="col-sm-4 col-form-label">
                  Charges framed in court
                </label>
                <div className="col-sm-8">
                  <select
                    className="form-control"
                    name="chargesFramed"
                    value={formik.values.chargesFramed}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    <option value="">Select</option>
                    {yesNoOptions.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>

                  {formik.touched.chargesFramed &&
                    formik.errors.chargesFramed && (
                      <div className="invalid-feedback d-block">
                        {formik.errors.chargesFramed}
                      </div>
                    )}
                </div>
              </div>

              {formik.values.chargesFramed === 'yes' && (
                <>
                  <div className="form-group row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Date of framing of charges by court
                    </label>
                    <div className="col-sm-8">
                      <input
                        type="date"
                        className="form-control"
                        name="chargesDate"
                        value={formik.values.chargesDate}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        onClick={(e) =>
                          e.target.showPicker && e.target.showPicker()
                        }
                      />

                      {formik.touched.chargesDate &&
                        formik.errors.chargesDate && (
                          <div className="invalid-feedback d-block">
                            {formik.errors.chargesDate}
                          </div>
                        )}
                    </div>
                  </div>

                  {/* Trial Status */}
                  <div className="form-group row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Trial Status
                    </label>
                    <div className="col-sm-8">
                      <select
                        className="form-control"
                        name="trialStatus"
                        value={formik.values.trialStatus}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      >
                        <option value="">Select</option>
                        {trialStatusOptions.map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </select>
                      {formik.touched.trialStatus &&
                        formik.errors.trialStatus && (
                          <div className="invalid-feedback d-block">
                            {formik.errors.trialStatus}
                          </div>
                        )}
                    </div>
                  </div>



                  {/* Trial Completed */}
                  {formik.values.trialStatus === 'trialCompleted' && (
                    <>



                      <div className="form-group row mb-3">
                        <label className="col-sm-4 col-form-label">
                          Date of Judgement
                        </label>
                        <div className="col-sm-8">
                          <input
                            type="date"
                            className="form-control"
                            name="judgmentDate"
                            value={formik.values.judgmentDate}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            onClick={(e) =>
                              e.target.showPicker && e.target.showPicker()
                            }
                          />
                          {formik.touched.judgmentDate &&
                            formik.errors.judgmentDate && (
                              <div className="invalid-feedback d-block">
                                {formik.errors.judgmentDate}
                              </div>
                            )}
                        </div>
                      </div>

                      <div className="form-group row mb-3">
                        <label className="col-sm-4 col-form-label">
                          Judgement Type
                        </label>
                        <div className="col-sm-8">
                          <select
                            className="form-control"
                            name="judgmentOutcome"
                            value={formik.values.judgmentOutcome}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          >
                            <option value="">Select</option>
                            {judgmentOutcomeOptions.map((opt) => (
                              <option key={opt.value} value={opt.value}>
                                {opt.label}
                              </option>
                            ))}
                          </select>
                          {formik.touched.judgmentOutcome &&
                            formik.errors.judgmentOutcome && (
                              <div className="invalid-feedback d-block">
                                {formik.errors.judgmentOutcome}
                              </div>
                            )}
                        </div>
                      </div>

                      {/* If Convicted → Sentence */}
                      {formik.values.judgmentOutcome === 'convicted' && (
                        <>
                          <div className="form-group row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Sentence Type
                            </label>
                            <div className="col-sm-8">
                              <select
                                className="form-control"
                                name="sentenceType"
                                value={formik.values.sentenceType}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              >
                                <option value="">Select</option>
                                {sentenceTypeOptions.map((opt) => (
                                  <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                  </option>
                                ))}
                              </select>
                              {formik.touched.sentenceType &&
                                formik.errors.sentenceType && (
                                  <div className="invalid-feedback d-block">
                                    {formik.errors.sentenceType}
                                  </div>
                                )}
                            </div>
                          </div>

                          {formik.values.sentenceType === 'imprisonment' && (
                            <>
                              <div className="form-group row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  Imprisonment Duration
                                </label>

                                <div className="col-sm-8 d-flex gap-2">

                                  {/* YEAR */}
                                  <select
                                    className="form-control"
                                    name="imprisonmentDurationYears"
                                    value={formik.values.imprisonmentDurationYears}
                                    onChange={formik.handleChange}
                                  >
                                    <option value="">Years</option>
                                    {Array.from({ length: 51 }, (_, i) => (
                                      <option key={i} value={i}>{i}</option>
                                    ))}
                                  </select>

                                  {/* MONTH */}
                                  <select
                                    className="form-control"
                                    name="imprisonmentDurationMonths"
                                    value={formik.values.imprisonmentDurationMonths}
                                    onChange={formik.handleChange}
                                  >
                                    <option value="">Months</option>
                                    {Array.from({ length: 12 }, (_, i) => (
                                      <option key={i} value={i}>{i}</option>
                                    ))}
                                  </select>

                                  {/* DAY */}
                                  <select
                                    className="form-control"
                                    name="imprisonmentDurationDays"
                                    value={formik.values.imprisonmentDurationDays}
                                    onChange={formik.handleChange}
                                  >
                                    <option value="">Days</option>
                                    {Array.from({ length: 31 }, (_, i) => (
                                      <option key={i} value={i}>{i}</option>
                                    ))}
                                  </select>

                                </div>
                              </div>

                            </>
                          )}

                          {formik.values.sentenceType ===
                            'bothImprisonmentAndFine' && (
                              <>
                                <div className="form-group row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Imprisonment Duration
                                  </label>

                                  <div className="col-sm-8 d-flex gap-2">

                                    {/* YEAR */}
                                    <select
                                      className="form-control"
                                      name="bothSentenceYears"
                                      value={formik.values.bothSentenceYears}
                                      onChange={formik.handleChange}
                                    >
                                      <option value="">Years</option>
                                      {Array.from({ length: 51 }, (_, i) => (
                                        <option key={i} value={i}>{i}</option>
                                      ))}
                                    </select>

                                    {/* MONTH */}
                                    <select
                                      className="form-control"
                                      name="bothSentenceMonths"
                                      value={formik.values.bothSentenceMonths}
                                      onChange={formik.handleChange}
                                    >
                                      <option value="">Months</option>
                                      {Array.from({ length: 12 }, (_, i) => (
                                        <option key={i} value={i}>{i}</option>
                                      ))}
                                    </select>

                                    {/* DAY */}
                                    <select
                                      className="form-control"
                                      name="bothSentenceDays"
                                      value={formik.values.bothSentenceDays}
                                      onChange={formik.handleChange}
                                    >
                                      <option value="">Days</option>
                                      {Array.from({ length: 31 }, (_, i) => (
                                        <option key={i} value={i}>{i}</option>
                                      ))}
                                    </select>

                                  </div>
                                </div>

                                <div className="form-group row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Fine Amount
                                  </label>
                                  <div className="col-sm-8">
                                    <input
                                      type="number"
                                      className="form-control"
                                      name="bothSentenceFine"
                                      value={formik.values.bothSentenceFine}
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.bothSentenceFine &&
                                      formik.errors.bothSentenceFine && (
                                        <div className="invalid-feedback d-block">
                                          {formik.errors.bothSentenceFine}
                                        </div>
                                      )}
                                  </div>
                                </div>
                              </>
                            )}
                          {formik.values.sentenceType === 'fine' && (
                            <div className="form-group row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Fine Amount
                              </label>
                              <div className="col-sm-8">
                                <input
                                  type="number"
                                  className="form-control"
                                  name="fineAmount"
                                  value={formik.values.fineAmount}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                />
                                {formik.touched.fineAmount &&
                                  formik.errors.fineAmount && (
                                    <div className="invalid-feedback d-block">
                                      {formik.errors.fineAmount}
                                    </div>
                                  )}
                              </div>
                            </div>
                          )}
                        </>
                      )}

                      <div className="form-group row mb-3">
                        <label className="col-sm-4 col-form-label">
                          Whether any appeal filed against the judgement
                        </label>
                        <div className="col-sm-8">
                          <select
                            className="form-control"
                            name="judgmentAgainstAppeal"
                            value={formik.values.judgmentAgainstAppeal}
                            onChange={formik.handleChange}
                          >
                            <option value="">Select</option>
                            <option key="yes" value="yes">YES </option>
                            <option key="no" value="no">NO </option>
                          </select>
                          {formik.touched.judgmentAgainstAppeal && formik.errors.judgmentAgainstAppeal && (
                            <div className="invalid-feedback d-block">
                              {formik.errors.judgmentAgainstAppeal}
                            </div>
                          )}
                        </div>
                      </div>


                      {formik.values.judgmentAgainstAppeal == 'yes' &&
                        <>
                          <div className="form-group row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Details of Appeal
                            </label>
                            <div className="col-sm-8">
                              <textarea
                                className="form-control"
                                name="judgmentDetailsOfAppeal"
                                value={formik.values.judgmentDetailsOfAppeal}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                              {formik.touched.judgmentDetailsOfAppeal && formik.errors.judgmentDetailsOfAppeal && (
                                <div className="invalid-feedback d-block">
                                  {formik.errors.judgmentDetailsOfAppeal}
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      }
                    </>
                  )}
                </>
              )}
            </>
          )}
        </>
      )}

      <div className="form-group row mb-3">
        <label className="col-sm-4 col-form-label">
          Remarks
        </label>
        <div className="col-sm-8">
          <textarea
            className="form-control"
            name="remarks"
            value={formik.values.remarks}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.remarks && formik.errors.remarks && (
            <div className="invalid-feedback d-block">
              {formik.errors.remarks}
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default FIRForm
